<template>
  <div class="container">
    <HeaderComponent :menu-id="1"></HeaderComponent>
    <div class="songping-box">
      <!-- 标题 -->
      <div class="title-ty">
        <div class="title-ty-y">SHUISHI GRADING</div>
        <div class="title-ty-z"><span>水石评级</span>古钱币送评</div>
      </div>
      <ul class="songping-list">
        <li class="songping-item" v-for="item in SongPingList" @click="songPingClick(item.path)">
          <img class="songping-item-icon" :src="require('@/assets/icon/'+ item.icon)" alt="">
          <div><span style="padding-right: 30px; font-weight: bold;">古钱币送评</span>{{ item.name }}</div>
        </li>
      </ul>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import GuanYuWoMenView from '../News/GuanYuWoMenView.vue';

export default {
  data() {
    return {
      SongPingList: [
        {
          name: '服务内容',
          icon: 'fuwuneirong.png',
          path: '/GuQianBi/FuWuNeiRong'
        },
        {
          name: '评级标准',
          icon: 'pingjibiaozhun.png',
          path: '/GuQianBi/PingJiBiaoZhun'
        },
        {
          name: '收费标准',
          icon: 'shoufeibiaozhun.png',
          path: '/GuQianBi/ShouFeiBiaoZhun'
        },
        {
          name: '免责条款',
          icon: 'mianzetiaokuan.png',
          path: '/GuQianBi/MianZeTiaoKuan'
        },
        {
          name: '赔付标准',
          icon: 'peifubiaozhun.png',
          path: '/GuQianBi/PeiFuBiaoZhun'
        }
      ]  
    }
  },
  methods: {
    songPingClick: function(url){
      this.$router.push(url)
    }
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.home-wrap {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 60px;
}
.songping-box{
  width: 1200px;
  margin: 0 auto;
}
.songping-list{
  margin: 100px auto;
  width: 1100px;
  .songping-item{
    width: 100%;
    padding: 0 150px;
    margin-bottom: 60px;
    border: 1px solid #E4AD51;
    height: 150px;
    display: flex;
    align-items: center;
    font-size: 32px;
    letter-spacing: 2px;
    cursor: pointer;
    .songping-item-icon{
      width: 100px;
      height: 100px;
      margin-right: 150px;
    }
  }
}
</style>